<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="transparent"
    flat
    height="65"
  >

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-bold text-uppercase"
      v-text="$route.meta.title"
    />

    <v-spacer />

    <div class="account-name primary--text">
        Bienvenu <strong> {{ userAuth.lastName }}</strong> !
    </div>
  </v-app-bar>
</template>

<script>

  import {mapState} from "vuex";

  export default {
    name: 'DashboardCoreAppBar',
    components: {
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
    }),

    computed: {
      ...mapState({
        userAuth: state => state.auth.user
      }),
    },

    methods: {

    },
  }
</script>
